export default __webpack_public_path__ + "static/icon-11-1-cf43a640c14fd20a5eb19b1232cf9a7a.png";